import { type ReactNode } from 'react'
import { cn } from '@util'
import { isEmpty, isNotDefined } from '@terros/common'
import { Text, Stack, type TextProps } from '@mantine/core'
import { Size } from '@front/model'
import { getSwitchedSections } from './util'

export type LabelDetailsProps = {
  details?: ReactNode
  detailsProps?: TextProps
  label?: ReactNode
  labelProps?: TextProps
  detailBold?: boolean
}

export const LabelDetails = (props: LabelDetailsProps): ReactNode => {
  const { label, details, labelProps, detailsProps } = getSwitchedSections(props)
  if (isNotDefined(label) && isNotDefined(details)) return
  return (
    <Stack
      align='start'
      gap={Size.space.md}
      style={{
        flexDirection: props.detailBold ? 'column-reverse' : 'column',
      }}
    >
      <Label label={label} labelProps={labelProps} />
      <Details details={details} detailsProps={detailsProps} />
    </Stack>
  )
}

const Label = ({ label, labelProps }: Pick<LabelDetailsProps, 'label' | 'labelProps'>): ReactNode => {
  if (isNotDefined(label)) return

  return typeof label === 'string' ? (
    <Text {...labelProps} className={cn('text-left', labelProps?.className)} flex={1}>
      {label}
    </Text>
  ) : (
    label
  )
}

const Details = ({ details, detailsProps }: Pick<LabelDetailsProps, 'details' | 'detailsProps'>): ReactNode => {
  if (isNotDefined(details)) return
  if (typeof details !== 'string') return details
  if (isEmpty(details)) return
  return (
    <Text c='dimmed' size='sm' {...detailsProps} className={cn('text-left', detailsProps?.className)} flex={1}>
      {details}
    </Text>
  )
}
